/* jshint undef: true, unused: true */
/* globals $, require */

const buildMedicationForm  = require('./medications/medicationForm');
const buildEquipmentForm   = require('./equipment/equipmentForm');
const saveHook             = require('../../../js_functions/saveHook');
const validationHook       = require('../../../js_functions/validationHook');
const showSectionHook      = require('../../../js_functions/showSectionHook');
const hideSectionHook      = require('../../../js_functions/hideSectionHook');

const medsEquipmentService = {};

function addSaveHook(contentTable, checkFormExists) {
  const isFormOpenAndValid = instance => instance.form && instance.validation.validate(instance.settings.uid);

  // this function returns a promise that will resolve either immediately
  // if the equipment / med form doesn't need saving or after it has finished
  // saving.
  const hook = () => new Promise((resolve) => {
    if (checkFormExists() && contentTable) {
      const instance = contentTable.getModalContentInstance();
      if(instance && isFormOpenAndValid(instance)) {
        contentTable.saveCurrentForm(resolve);
        return;
      }
    }
    resolve();
  });

  saveHook.add(hook);
}

function addValidationHook(contentTable, checkFormExists, validateFirst) {
  const isFormOpenAndNotValid = instance => instance.form && !instance.validation.validate(instance.settings.uid);

  const hook = () => {
    if (checkFormExists() && contentTable) {
      const instance = contentTable.getModalContentInstance();
      if(instance && isFormOpenAndNotValid(instance)) {
        return instance.settings.formModuleName();
      }
    }
    return null; // is valid
  };
  validationHook.add(hook, validateFirst);
}

// Setting up functions which check whether meds/equipment are visible.
// If they are when the form first loads, nothing happens.
// If not, setup a hook function which decides whether to open the meds/equipment forms when the sections are triggered open.
function addShowSectionHook(id, buttonId, contentTable) {
  const triggerClick = () => {
    // Once visible, trigger button which opens form.
    $(`#${id}`)
      .children('ul')
      .children(`li#${buttonId}`)
      .children('button')
      .first()
      .trigger('click');
  };

  showSectionHook.add(Section => {
    if(typeof contentTable !== 'object' || contentTable === null) {
      console.error('Content table is not an object', {Section, contentTable});
      return;
    }

    const displayedRowsCount = contentTable.displayRows.filter(row => !row.getIsFormDeleted()).length;

    if (Section === id && displayedRowsCount === 0) {
      triggerClick();
    }
  });
}

// This adds a hook that can close a form if the section is hidden
function addHideSectionHook(id, contentTable) {
  hideSectionHook.add(Section => {
    if (Section === id) {
      try {
        const instance = contentTable && contentTable.getModalContentInstance();
        if(instance) {
          contentTable.closeForm(instance.isEditedForm);
        }
      } catch (e) {
        console.error(`Error auto closing form: ${id}`);
      }
    }
  });
}

function initialiseForm({buildForm, formSelectorId, recordId, buttonId, validateFirst, renderForm}) {
  const formContainer = document.getElementById(formSelectorId);

  // This is used as an additional check that the form is present in the DOM
  const checkFormExists = () => $(`#${recordId}`).length > 0;

  medsEquipmentService[formSelectorId] = {
    sectionId: formSelectorId,
    checkFormExists,
    validate: () => false
  };

  if (formContainer) {
    buildForm(formSelectorId, renderForm)
      .then(function (contentTable) {
        addSaveHook(contentTable, checkFormExists);
        addValidationHook(contentTable, checkFormExists, validateFirst);
        addShowSectionHook(formSelectorId, buttonId, contentTable);
        addHideSectionHook(formSelectorId, contentTable);
        medsEquipmentService[formSelectorId].validate = () => {
          if (!checkFormExists()) return false;

          const instance = contentTable.getModalContentInstance();

          if (!instance.form) return false;

          return instance.validation.validate(instance.settings.uid);
        };
        medsEquipmentService[formSelectorId].validityReport = () => {
          if (!checkFormExists()) return [];

          return contentTable.getModalContentInstance().validation.validityReport();
        };
      })
      .catch(errorMessage => {
        throw `Error building form: ${errorMessage}`;
      });
  }
}

window.medsEquipmentService = medsEquipmentService;

$(function() {
  const globals = require('../../../js_functions/globalsWrapper')();

  const medsConfig = {
    buildForm            : buildMedicationForm,
    formSelectorId       : 'iq_medications',
    recordId             : 'medications-record-form',
    buttonId             : 'new-Medication-button-top',
    validateFirst        : true,
    renderForm           : !globals.usePhpMedsForm
  };

  const equipConfig = {
    buildForm            : buildEquipmentForm,
    formSelectorId       : 'iq_equipment',
    recordId             : 'equipmentform',
    buttonId             : 'new-Equipment-button-top',
    validateFirst        : false,
    renderForm           : !globals.usePhpEquipForm
  };
  initialiseForm(medsConfig);
  initialiseForm(equipConfig);
});
